/* KrakenTheMeta — the card detail sheet (image, cost, type, rules text, price, set, buy link).
 * KD.cardx.{img, info, scryInfo, buyBtn, buyUrl} build the pieces (the dashboard builder composes its own
 * sheet from them); KD.cardx.open(card, opts) shows a ready-made sheet for any stored or Scryfall card.
 */
import "./ui.js";
import "./cards.js";

(function () {
  "use strict";

  var KD = window.KD, D = KD.data, esc = KD.esc;
  if (KD.cardx) return;

  function priceText(c) { var p = parseFloat(c.price); return isNaN(p) ? "" : "$" + p.toFixed(2); }
  function frontCost(cost) { return String(cost || "").split("//")[0]; }

  function img(url, name) {
    var u = KD.safeUrl(url);
    return u ? '<img class="cardx__img" src="' + esc(u) + '" alt="' + esc(name) + '">'
      : '<div class="cardx__img cardx__img--none">' + esc(name) + "</div>";
  }
  function info(c) {
    var text = esc(c.oracleText || "").replace(/\{[^}]+\}/g, function (m) { return KD.mana(m); });
    var pt = c.power || c.toughness ? '<span class="badge">' + esc(c.power) + " / " + esc(c.toughness) + "</span>" : "";
    var price = priceText(c);
    return '<div class="row"><span class="pips">' + KD.mana(frontCost(c.manaCost)) + "</span>" + pt + "</div>" +
      '<p class="cardx__type">' + esc(c.types || "") + "</p>" +
      (text ? '<p class="cardx__text">' + text + "</p>" : "") +
      '<div class="row row--between"><span class="cardx__price">' + (price || '<span class="muted" style="font-size:15px">No price yet</span>') + "</span>" +
      '<span class="hint">' + esc(c.setName && c.setName !== "Unknown Set" ? c.setName : "") + "</span></div>";
  }
  // a Scryfall card in the stored shape, with both faces' rules text for two-faced cards
  function scryInfo(sc) {
    var sh = D.cardShape(sc, 1, false);
    if (!sh.oracleText && sc.card_faces) sh.oracleText = sc.card_faces.map(function (f) { return f.oracle_text || ""; }).join("\n\n");
    if (!sh.manaCost && sc.card_faces && sc.card_faces[0]) sh.manaCost = sc.card_faces[0].mana_cost || "";
    return sh;
  }
  function buyUrl(name) {
    return window.KTM_AFF ? window.KTM_AFF.cardLink(name, "magic") : "https://www.tcgplayer.com/search/magic/product?q=" + encodeURIComponent(name);
  }
  function buyBtn(name) {
    return '<a class="btn btn--ghost btn--sm" href="' + esc(buyUrl(name)) + '" target="_blank" rel="nofollow sponsored noopener">' + KD.icon("cart") + "<span>Buy on TCGplayer</span></a>";
  }

  // opts: { qty, actions (extra HTML), onOpen(sheet) }
  function open(card, opts) {
    opts = opts || {};
    var c = card.type_line !== undefined || card.image_uris || card.card_faces ? scryInfo(card) : card;
    var s = KD.sheet({
      title: esc(c.name), size: "lg",
      body: '<div class="cardx">' + img(c.imageUrl, c.name) + '<div class="cardx__info">' + info(c) +
        (opts.qty ? '<p class="hint">' + opts.qty + (opts.qty === 1 ? " copy" : " copies") + " in this deck</p>" : "") +
        '<div class="cardx__actions">' + buyBtn(c.name) + (opts.actions || "") + "</div></div></div>"
    });
    KD.ga("card_sheet_open", { card: c.name });
    if (opts.onOpen) opts.onOpen(s);
    return s;
  }

  /* Open at once from what the page already knows ({id?, name, imageUrl, manaCost, types, price}), then fill
   * in the rules text from Scryfall: the exact printing by id, else by exact name.
   * opts: { note (HTML under the info), actions (extra HTML), onCard(scryfallCard, sheet) } */
  function openLazy(stub, opts) {
    opts = opts || {};
    var s = KD.sheet({
      title: esc(stub.name), size: "lg",
      body: '<div class="cardx">' + img(stub.imageUrl, stub.name) + '<div class="cardx__info"><div data-info>' + info(stub) + '<p class="hint" data-loading>Loading rules text…</p></div>' +
        (opts.note || "") + '<div class="cardx__actions">' + buyBtn(stub.name) + (opts.actions || "") + "</div></div></div>"
    });
    var url = stub.id ? "https://api.scryfall.com/cards/" + encodeURIComponent(stub.id) : "https://api.scryfall.com/cards/named?exact=" + encodeURIComponent(stub.name);
    function done() { var l = KD.$("[data-loading]", s.el); if (l) l.remove(); }
    KD.data.scryfall(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sc) {
        var box = KD.$("[data-info]", s.el);
        if (!box) return;
        if (!sc) { done(); return; }
        var inf = scryInfo(sc);
        if (stub.price != null && stub.price !== "N/A" && stub.price !== "") inf.price = String(stub.price);
        box.innerHTML = info(inf);
        var ph = KD.$(".cardx__img--none", s.el);
        if (ph && inf.imageUrl) ph.outerHTML = img(inf.imageUrl, inf.name);
        if (opts.onCard) opts.onCard(sc, s);
      })
      .catch(done);
    return s;
  }

  KD.cardx = { img: img, info: info, scryInfo: scryInfo, buyBtn: buyBtn, buyUrl: buyUrl, open: open, openLazy: openLazy, priceText: priceText, frontCost: frontCost };
})();
